<template>
    <div>
        <slot
            :push="push"
        />
    </div>
</template>


<script lang="ts">
import Vue from "vue";
import Component from 'vue-class-component'

const GTMPushProps = Vue.extend({
    props: {
        country: {
            type: String,
            required: true
        }
    }
})

interface Window {
  dataLayer: Array<object>
}

@Component
export default class GTMPush extends GTMPushProps {
    push(event:Object) {
        window.dataLayer = (window as Window).dataLayer || [];
        window.dataLayer.push({
            event: 'ga4_event',
            country: this.country,
            ...event
        });
    }
}

</script>
